import type { QuestionType } from "@/types/question";
import api from "./api";

export type CreateQuestionRequest = {
	prompt: string;
	description?: string | null;
	type: QuestionType;
	Settings: {
		allowAnswerRecovery?: boolean;
		allowDefaultOption?: boolean;
		allowDamageReport?: boolean;
		minLength?: number;
		maxLength?: number;
		minValue?: number;
		maxValue?: number;
		dateRangeType?: number;
		minDate?: string;
		maxDate?: string;
		maxFiles?: number;
		maxFileSizeMB?: number;
		optionDisplayType?: number;
		isMultipleSelection?: boolean;
		Options?: Array<{
			label: string;
			position: number;
			isDefault?: boolean;
			isDamage?: boolean;
		}>;
	};
};

export async function createQuestion(body: CreateQuestionRequest) {
	try {
		const response = await api.post("/api/checklistquestion", body);
		return response.data;
	} catch (error: any) {
		if (!error.response) {
			throw new Error(
				"Não foi possível conectar ao servidor. Verifique sua conexão com a internet."
			);
		}
		throw error;
	}
}
